import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { generateQueryString } from "@/scripts/common/util";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";

const form = document.querySelector(".filter-form");
const pageSection = document.querySelector(".page-article");

const handleFilterChange = (e) => {
  e && e.preventDefault();

  const params = new FormData(form);
  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}` : form.action;

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterLink = (e) => {
  e.preventDefault();

  const linkUrl = new URL(e.delegateTarget.href);
  const currentUrl = new URL(window.location.href);

  linkUrl.searchParams.forEach((value, key) => {
    currentUrl.searchParams.set(key, value);
  });

  window.history.replaceState({}, "", currentUrl.href);

  updateResults();
};

const handleFilterClear = (e) => {
  e.preventDefault();

  form.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null));

  window.history.replaceState({}, "", form.action);

  updateResults();
};

const handleAllStories = (e) => {
  e.preventDefault();

  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.delete('category');

  window.history.replaceState({}, "", currentUrl.href);

  updateResults();
}

const handleAllLocations = (e) => {
  e.preventDefault();

  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.delete('location');

  window.history.replaceState({}, "", currentUrl.href);

  updateResults();
}

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    scrollToIfNeeded(pageContent, 84);
    pageSection.classList.add("is-filtered");
  } else {
    pageSection.classList.remove("is-filtered");
  }
};

document.addEventListener("DOMContentLoaded", () => {
  if (form) {
    delegate(".filter-link", "click", handleFilterLink);
    delegate(".filter-form", "submit", handleFilterChange);
    delegate(".filter-form-clear", "click", handleFilterClear);
    delegate(".filter-all-stories", "click", handleAllStories);
    delegate(".filter-all-locations", "click", handleAllLocations);
  }
});
